import {
	Component
} from '@angular/core'

@Component({
	selector: 'contact-error',
	templateUrl: '../views/contact-error.component.html'
})

export class ContactErrorComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/contact-error.component.ts